// Pure read helpers over MatchState shared by bots and the match engine.
// Importing only types keeps this free of cycles.

import { PERMANENT_DANGER_ZONES, ZONES } from './JKGame_content'
import type { Entity, MatchState } from './JKGame_types'

export function isForbidden(match: MatchState, zone: number): boolean {
  if (PERMANENT_DANGER_ZONES.has(zone)) return true // School — always lethal
  const pos = match.forbiddenOrder.indexOf(zone)
  return pos >= 0 && pos < match.forbiddenCount
}

export function safeZones(match: MatchState): number[] {
  const out: number[] = []
  for (let z = 0; z < ZONES.length; z++) if (!isForbidden(match, z)) out.push(z)
  return out
}

export function nextForbiddenZones(match: MatchState): number[] {
  return match.forbiddenOrder.slice(match.forbiddenCount, match.forbiddenCount + match.areaAdd)
}

export function aliveEntities(match: MatchState): Entity[] {
  return match.entities.filter((e) => e.alive)
}

export function getEntity(match: MatchState, id: string): Entity | undefined {
  return match.entities.find((e) => e.id === id)
}

/** Living entities in a zone, excluding an id. */
export function occupants(match: MatchState, zone: number, exceptId?: string): Entity[] {
  return match.entities.filter((e) => e.alive && e.zone === zone && e.id !== exceptId)
}

/** Count of living entities per zone (length = ZONES.length). */
export function zonePopulation(match: MatchState): number[] {
  const pop = new Array<number>(ZONES.length).fill(0)
  for (const e of match.entities) if (e.alive) pop[e.zone]++
  return pop
}

export function hpRatio(e: Entity): number {
  return e.mhp > 0 ? e.hp / e.mhp : 0
}
